import { ChangeEvent, useCallback, useRef } from 'react';
import classNames from 'classnames';

import CircleButton from '../CircleButton';
import { Button } from '../Button/Button';

import IUploadButton from './types';
import useStyles from './styles';

function UploadButton({
  children,
  onChange,
  accept,
  className,
  fab = false,
  multiple = false,
  disabled = false,
  variant = 'primary',
  size = 'large',
}: IUploadButton) {
  const classes = useStyles({ disabled });

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const processSelectedFiles = useCallback(
    async (event: ChangeEvent<HTMLInputElement>) => {
      const files = Array.from(event.target.files || []) as [File];
      event.target.value = '';

      onChange(files, 'button');
    },
    [onChange],
  );

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      {fab ? (
        <CircleButton
          className={classNames(classes.fab, className)}
          iconName="add-gen"
          onClick={triggerFileInput}
          disabled={disabled}
        />
      ) : (
        <Button
          className={className}
          onClick={triggerFileInput}
          variant={variant}
          size={size}
          disabled={disabled}
        >
          {children}
        </Button>
      )}
      <input
        ref={fileInputRef}
        className={classes.control}
        type="file"
        onChange={processSelectedFiles}
        disabled={disabled}
        multiple={multiple}
        {...(accept && { accept })}
      />
    </>
  );
}

export default UploadButton;
